import firebase from 'firebase/app'
import 'firebase/firestore'
import "firebase/messaging";
import "firebase/storage";

export const firebaseConfig = {
  apiKey: "AIzaSyB_zBtfAUHV4LmlwLbavgHqllvst8CW80A",
  authDomain: "rainmonitor-b0968.firebaseapp.com",
  projectId: "rainmonitor-b0968",
  storageBucket: "rainmonitor-b0968.appspot.com",
  messagingSenderId: "400767674708",
  appId: "1:400767674708:web:5138d740dfe63a19a340c1",
  measurementId: "G-B442SWT1ZZ"
};


// Get a Firestore instance
export const db = firebase
  .initializeApp(firebaseConfig)
  .firestore()

function getMessaging () {
  try {
    if (typeof window === 'undefined') return null
    if (!firebase.messaging || typeof firebase.messaging.isSupported !== 'function' || !firebase.messaging.isSupported()) {
      return null
    }
    return firebase.messaging()
  } catch (err) {
    console.warn('Firebase messaging is not available in this browser', err)
    return null
  }
}

export const messaging = getMessaging()

export const storage = firebase.storage();



// Export types that exists in Firestore
// This is not always necessary, but it's used in other examples
const { Timestamp, GeoPoint } = firebase.firestore
export { Timestamp, GeoPoint }

// if using Firebase JS SDK < 5.8.0
db.settings({ timestampsInSnapshots: true })
